import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { QueryParams } from "@webapp/core/abstracts/models/query-params.model";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { KpiStatistics, KpiStatisticsDTO } from "../kpi-statistics.models";
import { KpiStatisticsApiService } from "./kpi-statistics-api.service";
import { KpiStatisticsState } from "./kpi-statistics-state.service";

@Injectable()
export class KpiStatisticsFacade extends BaseFacade<KpiStatistics, KpiStatisticsDTO, KpiStatisticsState, KpiStatisticsApiService> {
  constructor(state: KpiStatisticsState, api: KpiStatisticsApiService) {
    super(state, api);
  }

  public getStatistics$(kpiId: string, queryParams?: QueryParams): Observable<KpiStatistics> {
    return this.get$(kpiId, {
      ...new RequestConfig(),
      url: this.apiService.getStatisticsForKpiEndpoint(kpiId),
      queryParams: queryParams,
    });
  }
}
